import { BaseFetch } from "../main-model"
export default class PurPlanModel extends BaseFetch {
    getPurPlanBy = (data) =>
        this.authFetch({
            url: "pur-plan/getPurPlanBy",
            method: "POST",
            body: JSON.stringify(data),
        })
    getPurPlanById = (data) =>
        this.authFetch({
            url: "pur-plan/getPurPlanById",
            method: "POST",
            body: JSON.stringify(data),
        })
    updatePurPlanById = (data) =>
        this.authFetch({
            url: "pur-plan/updatePurPlanById",
            method: "POST",
            body: JSON.stringify(data),
        })
    insertPurPlan = (data) =>
        this.authFetch({
            url: "pur-plan/insertPurPlan",
            method: "POST",
            body: JSON.stringify(data),
        })
    deletePurPlanById = (data) =>
        this.authFetch({
            url: "pur-plan/deletePurPlanById",
            method: "POST",
            body: JSON.stringify(data),
        })
}
